import { useLocation } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const { state } = useLocation();
  const onLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#F5F5F7] px-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-3xl p-8 md:p-10 shadow-[0_30px_80px_-50px_rgba(10,25,48,0.4)]" data-testid="admin-login-card">
        <div className="w-12 h-12 mx-auto rounded-2xl bg-white border border-slate-200 grid place-items-center overflow-hidden">
          <img src="/logo.png" alt="" className="h-9 w-auto" />
        </div>
        <h1 className="font-display text-2xl md:text-3xl text-[#0A1930] mt-6 text-center tracking-tight">Admin sign-in</h1>
        <p className="text-sm text-slate-500 text-center mt-2">For Those Who Served · Internal use only</p>

        {state?.error && (
          <div className="mt-5 rounded-2xl border border-red-200 bg-red-50 text-red-700 text-sm p-3 text-center" data-testid="admin-login-error">
            {state.error}
          </div>
        )}

        <button onClick={onLogin}
          className="mt-8 w-full h-12 rounded-full bg-[#0066CC] hover:bg-[#0055AA] text-white text-sm font-medium transition-colors flex items-center justify-center gap-2 active:scale-[0.99]"
          data-testid="admin-login-button">
          Continue with Google
        </button>
        <p className="text-xs text-slate-400 mt-6 text-center">Only authorized admin emails can access the dashboard.</p>
      </div>
    </div>
  );
}
